import React from "react";
import Card from "@albertsons/uds/molecule/Card";
import { DCOption } from "../utils/DCoption";

interface Props {
  selectedEnv: string;
  selectedDC: string;
  sourceenvValues: string[];
  selectedDCs: DCOption[];
  onEnvChange: (env: string) => void;
  onDCChange: (dc: string) => void;
}

const SourceQueryParams: React.FC<Props> = ({
  selectedEnv,
  selectedDC,
  sourceenvValues,
  selectedDCs,
  onEnvChange,
  onDCChange,
}) => {
  return (
    <Card collapsible title="Source Query Parameters" isOpen={true} className="min-w-[600px] mt15">
      <Card.Content>
        <div className="flex-container">
          <div>Source</div>
          <div>DC</div>
        </div>
        <div className="flex-container">
          <div className="inner-box">
            <select className="dropdown" value={selectedEnv} onChange={(e) => onEnvChange(e.target.value)}>
              {sourceenvValues.map((env) => (
                <option key={env} value={env}>
                  {env}
                </option>
              ))}
            </select>
          </div>
          <div className="inner-box">
            <select className="dropdown" value={selectedDC} onChange={(e) => onDCChange(e.target.value)}>
              <option value="" disabled>Select option</option>
              {selectedDCs.map((dc) => (
                <option key={dc.name} value={dc.name}>
                  {dc.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </Card.Content>
    </Card>
  );
};

export default SourceQueryParams;
